module.exports = __webpack_public_path__ + "img/cx1.c7d7da23.png";